let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2w0Qi")).then(() => parcelRequire('aUqM7'));